import React, { useEffect, useState, useRef } from "react";
import { Form, InputGroup } from "react-bootstrap";

const PsTextSearchBox = (props) => {
  const [value, setValue] = useState(props.value !== undefined ? props.value : null);
  const isFirstRender = useRef(true);

  const handleOnChange = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (value !== null && value !== undefined) {
      const timeoutId = setTimeout(() => callPropsFuc(), 400);
      return () => clearTimeout(timeoutId);
    }
  }, [value]);

  const callPropsFuc = () => {
    if (props.onSuccess) props.onSuccess(value);
  };

  useEffect(() => {
    if (props.value !== undefined) {
      setValue(props.value);
    }
  }, [props.value]);

  return (
    <>
      <InputGroup size={props.size || "sm"}>
        <InputGroup.Text>
          <i className="fa-solid fa-search"></i>
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder={props.placeholder || "Search.."}
          size={props.size || "sm"}
          value={value === null ? "" : value}
          onChange={(e) => handleOnChange(e)}
        />
      </InputGroup>
    </>
  );
};

export default PsTextSearchBox;
